import * as types from "../actions/actionTypes";

const initialState = {
  login: "",
  superAdmin: false,
  targetDirectories: [],
  token: "",
  environment: "",
  accountMetadataLabel: "",
  uploadEnabled: false
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_SET_INFORMATIONS:
      return {
        ...state,
        login: action.login,
        superAdmin: action.superAdmin,
        targetDirectories: action.targetDirectories,
        token: action.token,
        environment: action.environment,
        accountMetadataLabel: action.accountMetadataLabel,
        uploadEnabled: action.uploadEnabled
      };
    case types.LOGOUT_SUCCESS:
      return initialState;
    case types.APP_FLUSH_DATAS:
      return initialState;
    default:
      return state;
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js